import create from "zustand";
import {
  setEmpresaSession,
  clearEmpresaSession,
  getEmpresaToken,
  getEmpresaUser,
} from "../auth/api/empresaApi";
import type { EmpresaUser, EmpresaSessionResponse } from "../auth/api/empresaApi";

function toEmpresaUser(data: EmpresaSessionResponse): EmpresaUser {
  return {
    webcodigo: data.webcodigo,
    cliente_codigo: data.cliente_codigo,
    cliente_nome: data.cliente_nome,
    usuario: data.usuario,
    nome: data.nome,
    descricao: data.descricao,
    selecao: data.selecao,
    abrevaga: data.abrevaga,
    altvaga: data.altvaga,
    retcand: data.retcand,
  };
}

export interface EmpresaSessionState {
  token: string | null;
  user: EmpresaUser | null;
  setSession: (data: EmpresaSessionResponse) => void;
  clearSession: () => void;
  hydrateFromStorage: () => void;
}

export const useEmpresaStore = create<EmpresaSessionState>((set) => ({
  token: typeof window !== "undefined" ? getEmpresaToken() : null,
  user: typeof window !== "undefined" ? getEmpresaUser() : null,
  setSession: (data: EmpresaSessionResponse) => {
    const user = toEmpresaUser(data);
    setEmpresaSession(data.token, user);
    set({ token: data.token, user });
  },
  clearSession: () => {
    clearEmpresaSession();
    set({ token: null, user: null });
  },
  hydrateFromStorage: () => {
    if (typeof window === "undefined") return;
    const token = getEmpresaToken();
    const user = getEmpresaUser();
    if (token || user) {
      set({ token, user: user ?? null });
    }
  },
}));

const selectIsLoggedIn = (s: EmpresaSessionState) => !!(s.token && s.user);

export function useEmpresaIsLoggedIn(): boolean {
  return useEmpresaStore(selectIsLoggedIn);
}
